export const LOCALE_FR = {
    ORDER: "Commande",
    INVOICE: "Facture",
    INVOICES: "Factures",
    CREDIT_NOTE: "Avoir",
    CREDIT_NOTES: "Avoirs",
    CREATION_DATE: "Date d'émission",
    DELIVERY_DATE: "Date de livraison",
    DELIVERY_ADDRESS: "Adresse de livraison",
    DELIVERY_COST: "Frais de livraison",
    VENDOR: "Fournisseur",
    CUSTOMER: "Client",
    ORDER_NUMBER: "N° de commande",
    PAYMENT_METHOD: "Mode de paiement",
    NOTE: "Note",
    PRODUCT: "Article",
    PRODUCT_DESCRIPTION: "Description",
    PRODUCT_AMOUNT: "Quantité",
    PRODUCT_SINGLE_PRICE: "Prix unit.",
    DISCOUNT: "Remise",
    TOTAL_DISCOUNTS: "Total remise",
    TOTAL_BEFORE_DISCOUNTS: "Total hors remise",
    TAX_ABBREVIATED: "TVA",
    TAX_AMOUNT: "Montant de la taxe",
    SPLIT_AMOUNT: "Montant de la divisé",
    BRUTTO: "Brut",
    TOTAL: "Total",
    TOTAL_INCLUDING_VAT: "Total TTC",
    TOTAL_EXCLUDING_VAT: "Total hors TVA",
    VAT_ID: "N° de TVA",
    TAX_ID: "N° de taxe.",
    PAID: "Payé",
    UNPAID_AMOUNT: "Montant non payé",
    REASON: "Raison",
    INVOICE_LINE_ITEMS_TITLE: "Position dans la commande",
    CREDIT_NOTES_LINE_ITEMS_TITLE: "Avoirs sur commande",
    OTHER_CREDIT_NOTES: "Personnalisation de la commande",
    REFUND_SHIPPING_COST: "Frais de retour",
    REFUND_HAS_BEEN_PAID: "Le remboursement d'un montant de $VALUE a été versé.",
    REFUND_HAS_BEEN_PAID_FAILED: "Le remboursement d'un paiement de $VALUE a échoué",
    DOCUMENTS_FOR_ORDER: "Documents pour la commande",
    NO_INVOICES: " Pas encore de factures disponibles",
    NO_CREDIT_NOTES: "Pas encore d'avoirs disponibles",
    DOCUMENTS_ARE_GENERATING:
        "Les documents de facturation sont en cours de génération. S'il vous plait, réessayez dans quelques minutes.",
    INVALID_REQUEST_PATHWAY_SUPPORT:
        "Aucun document n'a été trouvé pour cette commande. Veuillez vous adresser à support@pathway-solutions.de",
    INVALID_REQUEST_GENERIC: "Aucun document n'a été trouvé pour cette commande. Veuillez vous adresser au revendeur.",
    INVALID_REQUEST_INDIVIDUAL_SUPPORT:
        "Aucun document n'a été trouvé pour cette commande. Veuillez vous adresser à ${MAIL}",
    GIFT_CARD_LINE: "Un code promo${GIFT_CARD_CODE} de ${GIFT_CARD_AMOUNT} a été utilisé pour cette commande",
    GIFT_CARD: "Carte cadeau",
    REVERSAL_INVOICE: "Facture d'annulatin",
    REVERSAL_CREDIT_NOTE: "Annulation de la note de crédit",
    DUTY: "Frais de douane",
    USED_DISCOUNTS: "Remises appliquées",
    PAYMENT_AT: "Paiement le $DATE",
    REFUNDED_CREDITNOTE_AT: "Remboursement de la note de crédit $CREDIT_NOTE le $DATE",
    REFUNDED_AT: "Remboursement le $DATE",
    PROCESSING_DOCUMENT: "Document en cours de traitement",
    DOWNLOAD_DOCUMENTS_TITLE: "Téléchargez vos documents ici!",
    MAIL_INTRODUCTION: "Pour toute question, veuillez contacter ${MAIL}",
    REPAYMENT_DIFFERENCE: "Différence de remboursement",
    DOCUMENT_PREVIEW_BANNER: "Aperçu – veuillez télécharger le PDF",
};
